export interface ListState {
  page?: number;
  pageSize?: number;
  sort?: { col: string; dir: "asc" | "desc" };
  filters?: Record<string, string>;
}

export function encodeListState(state: ListState): string {
  const params = new URLSearchParams();
  if (state.page !== undefined) params.set("page", String(state.page));
  if (state.pageSize !== undefined) params.set("pageSize", String(state.pageSize));
  if (state.sort) {
    params.set("sortCol", state.sort.col);
    params.set("sortDir", state.sort.dir);
  }
  if (state.filters) {
    for (const [k, v] of Object.entries(state.filters)) {
      params.set(`f.${k}`, v);
    }
  }
  return params.toString();
}

export function decodeListState(query: string): ListState {
  const params = new URLSearchParams(query);
  const state: ListState = {};

  const page = params.get("page");
  if (page !== null) state.page = Number(page);

  const pageSize = params.get("pageSize");
  if (pageSize !== null) state.pageSize = Number(pageSize);

  const sortCol = params.get("sortCol");
  const sortDir = params.get("sortDir");
  if (sortCol && (sortDir === "asc" || sortDir === "desc")) {
    state.sort = { col: sortCol, dir: sortDir };
  }

  const filters: Record<string, string> = {};
  for (const [k, v] of params.entries()) {
    if (k.startsWith("f.") && v) filters[k.slice(2)] = v;
  }
  if (Object.keys(filters).length > 0) state.filters = filters;

  return state;
}
